export default __webpack_public_path__ + "static/media/vr-headset.0318c5fd.png";